import angular from 'angular';

import { CartStatusChannel } from './services/cartStatusChannel';
import { ItemStatusChannel } from './services/itemStatusChannel';

export const CommonModule = angular
    .module('oo.order.common', [])
    .constant('CART_EVENTS', {
        CART_CONFIGURED: 'CART_CONFIGURED',
        CART_CHANGED: 'CART_CHANGED',
        CART_EDITED: 'CART_EDITED',
        CART_ERROR: 'CART_ERROR'
    })
    .service('cartStatusChannel', CartStatusChannel)
    .service('itemStatusChannel', ItemStatusChannel)
    .name;
